import axios from 'axios'

export default async function fetchData (url, method, data = null) {
  const accessToken = localStorage.getItem('access_token')
  const refreshToken = localStorage.getItem('refresh_token')
  const headers = {
    'X-Access-Token': accessToken,
    'X-Refresh-Token': refreshToken,
    Accept: 'application/json'
  }

  try {
    const response = await axios({
      url: url,
      method: method,
      headers: headers,
      data: data
    })
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error
  }
}
